/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TestIntegrationRequest
 */
export interface TestIntegrationRequest {
  /**
   *
   * @type {string}
   * @memberof TestIntegrationRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the TestIntegrationRequest interface.
 */
export function instanceOfTestIntegrationRequest(
  value: object,
): value is TestIntegrationRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function TestIntegrationRequestFromJSON(
  json: any,
): TestIntegrationRequest {
  return TestIntegrationRequestFromJSONTyped(json, false);
}

export function TestIntegrationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TestIntegrationRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function TestIntegrationRequestToJSON(
  json: any,
): TestIntegrationRequest {
  return TestIntegrationRequestToJSONTyped(json, false);
}

export function TestIntegrationRequestToJSONTyped(
  value?: TestIntegrationRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
